import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

import Axios from "@/lib/axios-instance";

// Type for the plan creation payload
type CreatePlanPayload = {
    name: string;
    price?: string;
    description?: string;
    plans_interval: string;
    is_active?: boolean;
};

// Mutation function that calls the API
export const createPlan = async (payload: CreatePlanPayload) => {
    try {
        const response = await Axios.post("/plan", payload);
        return response.data;
    } catch (error: any) {
        if (error.response) {
            throw new Error(`${error.response.data?.meta?.message || "An error occurred"}`);
        }
        throw new Error(error.message || "Network Error");
    }
};

// Custom hook for creating a plan
export const useCreatePlan = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (payload: CreatePlanPayload) => createPlan(payload),
        onSuccess: (data) => {
            queryClient.refetchQueries({ queryKey: ["get-all-feature-plans"] }); // Adjust query key if needed
            toast.success("Plan created successfully.");
            console.log({ data });
        },
        onError: (error: Error) => {
            toast.error("Unable to create plan.", { description: error.message });
            console.error({ error });
        },
    });
};
